import { render, staticRenderFns } from "./ApprovalReject.vue?vue&type=template&id=3ad2067c&scoped=true&"
import script from "./ApprovalReject.vue?vue&type=script&lang=js&"
export * from "./ApprovalReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad2067c",
  null
  
)

export default component.exports